
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  Heading,
  Row,
  StatusBar,
  HelperView,
  ButtonPrimary,
  MessageFoundation,
  LoaderIndicator
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { getInternalTransfer } from '@/modules/transaction/services/transfer/transfer-bff';
import {
  MovementDetails,
  MovementProductsDetails,
  StatusBarStages,
  SummaryDetails,
  SummaryDetailsRow,
  TransferWithdrawalResponse,
  EMovementDetailStyle,
  EStatusBarStyle,
  TransactionStage
} from '@/modules/transaction/services/transfer/transfer-bff-types';
import {
  addBodyScroll,
  toggleBodyScroll
} from '@/modules/common/helpers/browser';

@Component({
  components: {
    LoaderIndicator,
    Heading,
    StatusBar,
    Row,
    HelperView,
    ButtonPrimary,
    MessageFoundation
  }
})
export default class TransferWithdrawalDetails extends Vue {
  @Prop({ type: String, required: true })
  private id!: string;

  readonly NebraskaColors = NebraskaColors;

  private isLoading = false;
  private transfer!: TransferWithdrawalResponse;
  private hasError = false;

  created() {
    toggleBodyScroll();
  }

  beforeMount() {
    this.loadTransferDetails();
  }

  beforeDestroy() {
    addBodyScroll();
    this.hasError = false;
  }

  @Watch('id')
  private async loadTransferDetails() {
    this.isLoading = true;
    try {
      if (this.id) {
        const data = await getInternalTransfer(this.id);
        this.transfer = data.transferWithdrawalReceipt;
      }
    } catch (e) {
      this.hasError = true;
    } finally {
      this.isLoading = false;
    }
  }

  get summaryDetails(): SummaryDetails {
    return this.transfer?.summary;
  }

  get summaryDetailRows(): SummaryDetailsRow[] {
    return this.transfer?.summary?.rows || [];
  }

  get movementDetails(): MovementDetails | null {
    return this.transfer?.movementDetails;
  }

  get movementProductsDetails(): MovementProductsDetails[] {
    return this.transfer?.movementDetails?.products || [];
  }

  get statusBarStages(): StatusBarStages {
    return this.transfer?.statusBarStages;
  }

  get footerMessageFormatted() {
    if (!this.transfer) return null;
    else {
      if (this.footerMessageHelpContact) {
        return this.footerMessageContent + ' ' + this.footerMessageHelpContact;
      } else {
        return this.footerMessageContent;
      }
    }
  }

  get footerMessageContent() {
    return this.transfer.footer?.content;
  }

  get footerMessageHelpContact() {
    return this.transfer.footer?.helpContact;
  }

  get stagesMapper() {
    return this.statusBarStages.stages.map(
      (statusBarStage: TransactionStage) => ({
        title: statusBarStage.title,
        description: statusBarStage.subtitle
      })
    );
  }

  movementProductDetailStyle(style: string) {
    return style === EMovementDetailStyle.Bold
      ? 'transfer-content__description--bold'
      : '';
  }

  statusBarStyle(style: string) {
    return style === EStatusBarStyle.Canceled
      ? NebraskaColors.statusNegativeBackground
      : NebraskaColors.statusPositiveBackground;
  }
}
